import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/** Stable public signals so Wappalyzer can classify storefronts as Ecommerce → Mera Startup. */
export const MERA_STARTUP_PLATFORM = "Mera Startup";
export const MERA_STARTUP_WEBSITE = "https://merastartup.in";

export default function StorefrontFingerprint() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const prev = window.MeraStartup && typeof window.MeraStartup === "object" ? window.MeraStartup : {};
    window.MeraStartup = {
      ...prev,
      platform: MERA_STARTUP_PLATFORM,
      website: MERA_STARTUP_WEBSITE,
      category: "Ecommerce",
    };
  }, []);

  return (
    <>
      <Helmet>
        <html data-ecommerce="mera-startup" data-generator="Mera Startup" />
        <meta name="generator" content={MERA_STARTUP_PLATFORM} />
        <meta name="application-name" content={MERA_STARTUP_PLATFORM} />
        <meta name="platform" content={MERA_STARTUP_PLATFORM} />
        <link rel="author" title={MERA_STARTUP_PLATFORM} href={MERA_STARTUP_WEBSITE} />
        <script src="/mera-startup-commerce.js" defer />
      </Helmet>
      <div
        id="mera-startup-storefront"
        className="mera-startup-storefront"
        data-platform={MERA_STARTUP_PLATFORM}
        data-website={MERA_STARTUP_WEBSITE}
        hidden
      />
    </>
  );
}
